import {IRolesRepository} from "@/repository/user/roles/RolesRepository.types";
import {IRoles, RolesResponseType} from "@/entity/user/roles/roles.types";
import Api from "@/repository/api";
import Roles from "@/entity/user/roles/roles";

export default class RolesRepository implements IRolesRepository {
    async fetchAll(): Promise<IRoles[]> {
        const response = await Api.get('/roles/get');
        const respData = response.data as RolesResponseType[];
        return respData.map((role: RolesResponseType) => new Roles(role));
    }
}